import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 1.875rem 0;
    padding-bottom: 1.875rem;
`;

export const WrapperAccordion = styled.div`
    margin: 0.9375rem 0 1.875rem 0;
`;